import * as Auth from './authentication'
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/forbidden',
    name: 'Forbidden',
    component: () => import(/* webpackChunkName: "forbidden" */ '@/views/auth/Forbidden.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/auth/Login.vue')
  },
  {
    path: '/logout',
    name: 'Logout',
    beforeEnter: Auth.logOut,
    component: () => {},
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import(/* webpackChunkName: "register" */ '@/views/auth/Register.vue')
  },
  {
    path: '/',
    name: 'default',
    component: () => import(/* webpackChunkName: "main" */ '@/views/default/Main.vue'),
    redirect: { name: 'Home' },
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import(/* webpackChunkName: "home-page" */ '@/views/default/pages/HomePage.vue'),
        beforeEnter: Auth.requiresAtLeastUser
      },
      // {
      //   path: 'node',
      //   name: 'NodeData',
      //   component: () => import(/* webpackChunkName: "node-data-page" */ '@/views/default/pages/NodeData.vue'),
      //   beforeEnter: Auth.requiresModeratorOrUser
      // },
      {
        path: 'buiten-gebruik',
        name: 'EMRAsOutOfUse',
        component: () => import(/* webpackChunkName: "out-of-use-page" */ '@/views/default/pages/OutOfUsePage.vue'),
        beforeEnter: Auth.requiresAtLeastModerator
      },
      {
        path: 'preparatie',
        name: 'EMRAsPrepared',
        component: () => import(/* webpackChunkName: "prepared-emras-page" */ '@/views/default/pages/PreparationPage.vue'),
        beforeEnter: Auth.requiresAtLeastModerator
      },
      {
        path: 'emra',
        children: [ 
          {
            path: '',
            name: 'EMRAPage',
            component: () => import(/* webpackChunkName: "emra-page" */ '@/views/default/pages/EMRAPage.vue'),
            beforeEnter: Auth.requiresEmployed
          },
          {
            path: 'rapportage',
            component: () => import(/* webpackChunkName: "report" */ '@/views/default/pages/report/ReportPage.vue'),
            beforeEnter: Auth.requiresEmployed,
            children: [
              {
                path: 'berekeningen',
                name: 'ModNode',
                component: () => import(/* webpackChunkName: "report-data" */ '@/views/default/pages/report/DataPage.vue'),
                beforeEnter: Auth.requiresEmployed
              },
              {
                path: 'grafieken',
                name: 'ReportGraphs',
                component: () => import(/* webpackChunkName: "report-graphs" */ '@/views/default/pages/report/GraphsPage.vue'),
                beforeEnter: Auth.requiresEmployed
              },
            ],
          },
          {
            path: 'metingen',
            name: 'DataPage',
            component: () => import(/* webpackChunkName: "data-page" */ '@/views/default/pages/DataPage.vue'),
            beforeEnter: Auth.requiresAtLeastUser
          }
        ] 
      },
      {
        path: 'toevoegen',
        name: 'AddEMRA',
        component: () => import(/* webpackChunkName: "add-emra" */ '@/views/default/pages/AddEMRA.vue'),
        beforeEnter: Auth.requiresAtLeastModerator
      },
      {
        path: '/admin',
        name: 'Admin',
        // component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/Main.vue'),
        children: [
          {
            path: 'groepen',
            name: 'GroupsPage',
            component: () => import(/* webpackChunkName: "users" */ '@/views/default/pages/GroupsPage.vue'),
            beforeEnter: Auth.requiresAtLeastModerator
          },
          {
            path: 'gebruikers',
            name: 'Users',
            component: () => import(/* webpackChunkName: "create-user" */ '@/views/default/pages/UsersPage.vue'),
            beforeEnter: Auth.requiresAdmin
          }
        ],
        beforeEnter: Auth.requiresAtLeastModerator,
      },
    ],
    beforeEnter: Auth.requiresAtLeastUser
  },
  {
    path: '/(.*)',
    redirect: '/login'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  Auth.keepAliveHealthyTokens()
  next()
})


export default router
